import React, { FC, memo } from 'react';
import { Badge } from '@silverfort/sf-components';
import { applicationCriticalityByValue } from '../../../common';
import { Application } from '../../../types/Application';

const Skeleton: FC = () => (
    <>
        <div className="h-5 w-2/5 bg-sf-gray-200 rounded" />

        <div className="flex gap-2 items-center">
            <div className="h-6 w-24 bg-sf-gray-200 rounded-lg" />
            <div className="h-3 w-3 bg-sf-gray-200 rounded-full" />
            <div className="h-4 w-52 bg-sf-gray-200 rounded" />
        </div>
    </>
);

type ApplicationHeaderProps = {
    application?: Application;
    loading: boolean;
};

export const ApplicationHeader: FC<ApplicationHeaderProps> = memo(({ application, loading }) => {
    const businessCriticality = application?.business_criticality
        ? applicationCriticalityByValue[application.business_criticality]
        : undefined;

    return (
        <section className="p-6 border border-gray-100 rounded-2xl flex flex-col gap-4">
            {!loading && application ? (
                <>
                    <span className="text-15 font-medium font-sf-poppins">{application.name}</span>

                    <span className="flex gap-2 items-center">
                        {businessCriticality && <Badge color="secondary" text={businessCriticality.title} />}

                        {application.description && (
                            <>
                                <span className="text-sf-gray-500 text-13">•</span>
                                <span className="text-sf-gray-500 text-13">{application.description}</span>
                            </>
                        )}
                    </span>
                </>
            ) : (
                <Skeleton />
            )}
        </section>
    );
});
